import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import {
  FaTrophy,
  FaBriefcase,
  FaMapMarkerAlt,
  FaGraduationCap,
  FaStar,
} from "react-icons/fa";
import "./Achievement.css";
import breadcrumb from "../../assets/breadcrumb/Awards.jpg";

const API_BASE_URL =process.env.REACT_APP_API_BASE_URL;

function Achievement() {
  const [alumniData, setAlumniData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/achievements/public`);
        const data = await response.json();
        setAlumniData(data);
      } catch (error) {
        console.error("Failed to fetch achievements:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAchievements();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Student Achievements | Sucheta Kriplani Teacher Training College
          (SKTTC), Jodhpur
        </title>

        {/* Preload hero background image */}
        <link rel="preload" as="image" href={breadcrumb} />

        <meta
          name="description"
          content="Explore the achievements of B.Ed students at Sucheta Kriplani Teacher Training College (SKTTC), Manaklao, Jodhpur including merit holders, PTET qualifiers, academic excellence, and successful teaching careers."
        />

        <meta
          name="keywords"
          content="SKTTC Student Achievements, Sucheta Kriplani College Alumni, B.Ed Merit Holders Jodhpur, PTET Qualifiers, Teaching Career Success, JNVU Affiliated College Achievements"
        />

        <meta
          property="og:title"
          content="Student Achievements | SKTTC Jodhpur"
        />

        <meta
          property="og:description"
          content="Discover the academic excellence and professional success stories of B.Ed students from Sucheta Kriplani Teacher Training College (SKTTC), affiliated with JNVU and approved by NCTE."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://suchetabedcollege.org/achievements"
        />

        <link
          rel="canonical"
          href="https://suchetabedcollege.org/achievements"
        />
      </Helmet>

      <div className="achievement-of-sk-college-wrapper">
        {/* 1. Hero / Breadcrumb Section */}
        <div
          className="achievement-of-sk-college-hero"
          style={{ backgroundImage: `url(${breadcrumb})` }}
        >
          <div className="achievement-of-sk-college-overlay"></div>
          <div className="achievement-of-sk-college-hero-content">
            <h1 className="achievement-of-sk-college-main-title">
              Student Achievement
            </h1>
            <div className="achievement-of-sk-college-breadcrumb-text">
              <span>Home</span>
              <span className="achievement-of-sk-college-sep">/</span>
              <span className="achievement-of-sk-college-active">
                Student Achievement
              </span>
            </div>
          </div>
        </div>

        {/* 2. Intro & Stats Section */}
        <div className="achievement-of-sk-college-intro-section">
          <div className="achievement-of-sk-college-container">
            <p className="achievement-of-sk-college-quote">
              "Our students continue to make us proud by excelling in academics,
              careers, and public service."
            </p>
            <div className="achievement-of-sk-college-stats">
              <div className="achievement-of-sk-college-stat-item">
                <FaTrophy className="achievement-of-sk-college-stat-icon" />
                <div>
                  <strong>150+</strong>
                  <span>Govt Selections</span>
                </div>
              </div>
              <div className="achievement-of-sk-college-stat-item">
                <FaStar className="achievement-of-sk-college-stat-icon" />
                <div>
                  <strong>50+</strong>
                  <span>Merit Holders</span>
                </div>
              </div>
              <div className="achievement-of-sk-college-stat-item">
                <FaBriefcase className="achievement-of-sk-college-stat-icon" />
                <div>
                  <strong>500+</strong>
                  <span>Career Placements</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 3. Main Grid Section */}
        <div className="achievement-of-sk-college-grid-section">
          <div className="achievement-of-sk-college-container">
            <div className="achievement-of-sk-college-grid">
              {loading ? (
                <div className="achievement-of-sk-college-loading">
                  Loading Achievements...
                </div>
              ) : alumniData.length === 0 ? (
                <div className="achievement-of-sk-college-no-data">
                  No achievements found yet.
                </div>
              ) : (
                alumniData.map((student) => (
                  <div
                    key={student._id}
                    className="achievement-of-sk-college-card"
                  >
                    <div className="achievement-of-sk-college-card-bg-shape"></div>
                    <div className="achievement-of-sk-college-photo-wrapper">
                      <div className="achievement-of-sk-college-photo-frame">
                        <img
                          src={`${API_BASE_URL}${student.image}`}
                          alt={student.name}
                          onError={(e) =>
                            (e.target.src =
                              "https://via.placeholder.com/400x400?text=No+Image")
                          }
                        />
                      </div>
                    </div>
                    <div className="achievement-of-sk-college-details">
                      <h3 className="achievement-of-sk-college-name">
                        {student.name}
                      </h3>
                      <div className="achievement-of-sk-college-batch-badge">
                        <FaGraduationCap /> {student.degree} – {student.year}
                      </div>
                      <div className="achievement-of-sk-college-divider"></div>
                      <div className="achievement-of-sk-college-designation">
                        <h4>{student.post}</h4>
                        <p className="achievement-of-sk-college-location">
                          <FaMapMarkerAlt /> {student.location}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Achievement;
